<template>
  <div>
    <review-criteria-list
      :review-criteria="reviewCriteria"
      :criteria-type="criteriaType"
      allow-delete
      max-height="unset"
      @save-criteria="$emit('save-criteria', $event)"
      @delete-criteria="$emit('delete-criteria', $event)"
    >
      <review-criteria-list-item
        v-for="(criteria, i) in pendingCriteria"
        :key="criteria.id"
        :value="criteria"
        :index="reviewCriteria.length + 1 + i"
        editing
        @input="onPendingCriteriaInput(i, $event)"
        @save="savePendingCriteria(i, criteria)"
        @delete="deletePendingCriteria(criteria)"
      />
      <v-btn
        :color="addButtonColor"
        tile
        elevation="0"
        block
        class="text-none"
        height="48"
        @click="addPendingCriteria"
      >
        <v-icon left>add</v-icon>
        Add
      </v-btn>
    </review-criteria-list>
  </div>
</template>

<script>
import ReviewCriteriaList from '@/components/ReviewSettingsPage/ReviewCriteriaList';
import ReviewCriteriaListItem from '@/components/ReviewSettingsPage/ReviewCriteriaListItem';
import { Review, ReviewCriteria } from '@/models';
import { CriteriaType } from '@/enums';

export default {
  name: 'ReviewCriteriaForm',
  components: {
    ReviewCriteriaList,
    ReviewCriteriaListItem,
  },
  props: {
    review: {
      type: Review,
      required: true,
    },
    reviewCriteria: {
      type: Array,
      default: () => [],
    },
    criteriaType: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    pendingCriteria: [],
  }),
  computed: {
    addButtonColor() {
      return this.criteriaType === CriteriaType.INCLUSION
        ? 'success'
        : 'error';
    },
  },
  methods: {
    onPendingCriteriaInput(index, value) {
      this.$set(this.pendingCriteria, index, value);
    },
    addPendingCriteria() {
      this.pendingCriteria.push(this.generateBlankCriteria());
    },
    deletePendingCriteria(criteria) {
      this.pendingCriteria = this.pendingCriteria.filter(
        (pendingCriteria) => pendingCriteria !== criteria
      );
    },
    savePendingCriteria(index, criteria) {
      this.$emit('save-criteria', criteria);
      if (this.pendingCriteria.length > 1) {
        this.deletePendingCriteria(criteria);
      } else {
        const blankCriteria = this.generateBlankCriteria();
        this.$set(this.pendingCriteria, index, blankCriteria);
      }
    },
    generateBlankCriteria() {
      return new ReviewCriteria({
        criteriaType: this.criteriaType,
        review: this.review,
      });
    },
  },
};
</script>
